import { getBatteryServiceLife } from '../../../../helpers/getBatteryServiceLife';
import { getUsedWithNames } from '../../../../helpers/getUsedWithNames';

import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import RingGauge from 'pages/MaintenancePage/components/RingGauge';
import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const TabPanelBatteryOverview: FunctionComponent<Props> = ({
    battery,
    className = '',
    cycleInterval,
    droneNames,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const serviceLife = getBatteryServiceLife({ battery, cycleInterval });
    const usedWithNames = getUsedWithNames({ droneIds: battery.droneIds, droneNames });
    const usedWithText = usedWithNames.length > 0 ? usedWithNames.join(', ') : t.EM_DASH;
    const lastInstalledName = battery.lastInstalledDroneId
        ? (droneNames[battery.lastInstalledDroneId] ?? t.EM_DASH)
        : t.EM_DASH;
    const statusLog = battery.lifecycleStatusLog;
    const rows = [
        { label: t.USED_WITH, value: usedWithText },
        { label: t.LAST_INSTALLED, value: lastInstalledName },
        { label: t.LAST_SYNC, value: battery.lastSync.label },
        ...(statusLog
            ? [{ label: t.STATUS_UPDATED, value: `${statusLog.by} · ${statusLog.at.slice(0, 10)}` }]
            : [])
    ];

    return (
        <VerticalContainer
            className={`${styles.tabPanelBatteryOverview} ${className}`}
            testId={testId}>
            <Wrapper className={styles.ringRow}>
                <RingGauge
                    label={t.CYCLE_LIFE_LABEL}
                    notConfiguredText={t.NOT_CONFIGURED}
                    serviceLife={serviceLife}
                    size='large'
                />
            </Wrapper>

            <VerticalContainer className={styles.usedWith}>
                {rows.map(row => (
                    <HorizontalContainer className={styles.row} key={row.label}>
                        <Wrapper className={styles.label}>{row.label}</Wrapper>

                        <Wrapper className={styles.value}>{row.value}</Wrapper>
                    </HorizontalContainer>
                ))}
            </VerticalContainer>
        </VerticalContainer>
    );
};

export default TabPanelBatteryOverview;
